import React from "react";
import { Col, Row, Typography } from "antd";
import DetailBarCard from "../../../../shared/DetailBarCard";

const getSpan = (cardCount, screenWidth) => {
  if (screenWidth < 1100) {
    // For screens smaller than 1100px, use a maximum of 4 cards per row
    return 6; // 24 / 4 = 6
  }

  if (screenWidth < 1430) {
    // For screens between 1100px and 1430px, use a maximum of 6 cards per row
    return Math.max(4, Math.floor(24 / Math.min(cardCount, 6)));
  }

  if (cardCount <= 2) return 6; // fixed card width for 1 or 2 cards

  const baseSpan = Math.floor(24 / cardCount); // base span for each card
  const extraSpace = 24 % cardCount; // remaining space after division

  // Distribute the extra space evenly among the cards
  const size = baseSpan + (extraSpace > 0 ? 1 : 0);
  return size <= 2 ? 3 : size;
};

const DetailBarCards = ({ name, dataToDisplay }) => {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const span = getSpan(dataToDisplay.values.length, windowWidth);

  return dataToDisplay.values.map((item, index) => (
    <Col key={`${name}-${index}`} xs={24} sm={12} md={8} lg={span}>
      <DetailBarCard {...item} />
    </Col>
  ));
};

const DetailBar = ({
  name = "",
  dataToDisplay = { visible: false, values: [] },
}) => {
  if (!dataToDisplay.visible) return null;

  return (
    <React.Fragment>
      <Typography.Title level={4}>{name}</Typography.Title>
      <Row gutter={[16, 16]}>
        <DetailBarCards name={name} dataToDisplay={dataToDisplay} />
      </Row>
    </React.Fragment>
  );
};

export default DetailBar;
